export const toSentenceCase = (str: string) => {
  return str[0].toUpperCase() + str.slice(1);
};

export const toSnakeCase = (str: string) => {
  const result = str.slice(1).replace(/([A-Z])/g, ' $1');
  return str[0].toLowerCase() + result.split(' ').join('_').toLowerCase();
};

export function enumFromStringValue<T>(enm: { [s: string]: T }, value: string | undefined): T | undefined {
  if (value == null) return undefined;
  return (Object.values(enm) as unknown as string[]).includes(value) ? (value as unknown as T) : undefined;
}

type Split<Str extends string, Delimiter extends string> = string extends Str
  ? string[]
  : Str extends `${infer Word}${Delimiter}${infer Rest}`
    ? [Word, ...Split<Rest, Delimiter>]
    : [Str];

export function split<Str extends string, Delimiter extends string>(
  str: Str,
  delimiter: Delimiter
): Split<Str, Delimiter> {
  return str.split(delimiter) as Split<Str, Delimiter>;
}

type StartsWith<Str extends string, SearchStr extends string> = Str extends `${SearchStr}${infer _}` ? true : false;

export function startsWith<Str extends string, SearchStr extends string>(
  str: Str,
  searchString: SearchStr
): StartsWith<Str, SearchStr> {
  return str.startsWith(searchString) as StartsWith<Str, SearchStr>;
}
